import L from 'leaflet'
import checkpoint from './Pin/checkpoint.svg'
import location from './Pin/location.svg'
import checked from './Pin/checkpoint2.svg'
import editChecked from './Pin/checkpoint-edit.svg'

const iconCheckpoint = new L.Icon({
  iconUrl: checkpoint,
  iconRetinaUrl: checkpoint,
  iconSize: [30, 50],
  iconAnchor: [15, 50],
})
const iconLocation = new L.Icon({
  iconUrl: location,
  iconRetinaUrl: location,
  iconSize: [20, 40],
  iconAnchor: [10, 40],
})
const iconChecked = new L.Icon({
  iconUrl: checked,
  iconRetinaUrl: checked,
  iconSize: [30, 50],
  iconAnchor: [15, 50],
})
const iconEditing = new L.Icon({
  iconUrl: editChecked,
  iconRetinaUrl: editChecked,
  iconSize: [30, 50],
  iconAnchor: [15, 50],
})

export { iconCheckpoint, iconLocation, iconChecked, iconEditing }
